import { parse as n } from "querystring";
import * as r from "ramda";
const u = (t, s, p = !1) => {
  const e = r.prop(s, t);
  return r.isNil(e) ? null : p ? r.flatten([e]) : p ? null : Array.isArray(e) ? r.propOr("", "0", e) : e;
}, l = r.pipe(
  r.split("?"),
  r.head,
  r.split("#"),
  r.head
), c = (t, s = []) => {
  const e = r.pipe(
    r.split("?"),
    r.propOr("", "1")
  )(t), i = Object.keys(n(e));
  return !r.isEmpty(r.difference(i, s));
};
export {
  c as hasQuery,
  u as queryGet,
  l as removeQuery
};
//# sourceMappingURL=query.js.map
